"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ScienceAxis: ['science-axis', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,20a1,1,0,0,0-1-1H17.773a.251.251,0,0,1-.185-.419c2.5-2.745,3.307-7.334,3.469-11.1a.5.5,0,0,1,.5-.478H22.5a1,1,0,0,0,.707-1.707l-2.5-2.5a1,1,0,0,0-1.414,0l-2.5,2.5A1,1,0,0,0,17.5,7h1.049a.5.5,0,0,1,.5.523c-.144,3.119-.769,7.336-2.938,9.71a5.173,5.173,0,0,1-2.477,1.555A.5.5,0,0,1,13,18.3V16a.5.5,0,0,1,.5-.5h.177a1,1,0,0,0,0-2H13.5A.5.5,0,0,1,13,13V10.5a.5.5,0,0,1,.5-.5h.177a1,1,0,0,0,0-2H13.5a.5.5,0,0,1-.5-.5V1a1,1,0,0,0-2,0V7.5a.5.5,0,0,1-.5.5h-.323a1,1,0,0,0,0,2H10.5a.5.5,0,0,1,.5.5V13a.5.5,0,0,1-.5.5h-.323a1,1,0,0,0,0,2H10.5a.5.5,0,0,1,.5.5v2.3a.5.5,0,0,1-.634.481A5.183,5.183,0,0,1,7.89,17.231c-2.166-2.37-2.792-6.59-2.937-9.712A.5.5,0,0,1,5.453,7H6.5a1,1,0,0,0,.707-1.707l-2.5-2.5a1,1,0,0,0-1.414,0l-2.5,2.5A1,1,0,0,0,1.5,7h.944a.5.5,0,0,1,.5.478c.162,3.771.964,8.359,3.469,11.1A.251.251,0,0,1,6.227,19H1a1,1,0,0,0,0,2h9.5a.5.5,0,0,1,.5.5V23a1,1,0,0,0,2,0V21.5a.5.5,0,0,1,.5-.5H23A1,1,0,0,0,24,20Z']],
  ScienceMoleculeStrucutre: ['science-molecule-strucutre', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.24,5.456,18.217,3.742a1.5,1.5,0,0,0-1.49,0l-2.6,1.494a.5.5,0,0,1-.435.031L10.314,3.918A.5.5,0,0,1,10,3.454V2.124a1.244,1.244,0,0,0-.691-1.118L7.559.131a1.256,1.256,0,0,0-1.118,0l-1.75.875A1.244,1.244,0,0,0,4,2.124V4.291A1.244,1.244,0,0,0,4.679,5.4l1.75.9a1.25,1.25,0,0,0,1.142,0L8.819,5.66a.505.505,0,0,1,.415-.02l3.452,1.381A.5.5,0,0,1,13,7.486V9.679a1.5,1.5,0,0,0,.756,1.3l1.617.923a.251.251,0,0,1,.024.419L12.19,14.7a.5.5,0,0,1-.541.036l-3.42-1.9a1.493,1.493,0,0,0-1.458,0l-4,2.222A1.5,1.5,0,0,0,2,16.365v3.912a1.5,1.5,0,0,0,.771,1.311l4,2.223a1.5,1.5,0,0,0,1.458,0l4-2.223a1.5,1.5,0,0,0,.77-1.31V16.838a.5.5,0,0,1,.2-.4,71.223,71.223,0,0,1,8.039-5.453A1.5,1.5,0,0,0,22,9.679V6.761A1.5,1.5,0,0,0,21.24,5.456ZM7.228,4.229a.5.5,0,0,1-.456,0l-.5-.257A.5.5,0,0,1,6,3.527V2.9a.5.5,0,0,1,.276-.447l.5-.25a.5.5,0,0,1,.448,0l.5.25A.5.5,0,0,1,8,2.9v.63a.5.5,0,0,1-.272.445ZM11,19.689a.5.5,0,0,1-.257.437l-3,1.666a.5.5,0,0,1-.486,0l-3-1.666A.5.5,0,0,1,4,19.689V16.954a.5.5,0,0,1,.257-.438l3-1.666a.5.5,0,0,1,.486,0l3,1.666a.5.5,0,0,1,.257.438ZM20,9.1a.5.5,0,0,1-.252.434l-2,1.143a.5.5,0,0,1-.5,0l-2-1.143A.5.5,0,0,1,15,9.1V7.337a.5.5,0,0,1,.25-.433l1.98-1.14a.5.5,0,0,1,.5,0l2.021,1.146A.5.5,0,0,1,20,7.343Z']],
  ScienceNeurons: ['science-neurons', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.086,18.4a1,1,0,0,0-.407-1.354L20.43,15.839a.249.249,0,0,1-.131-.207,2.639,2.639,0,0,0-1.061-1.972.25.25,0,0,1-.1-.2V10.54a.25.25,0,0,1,.1-.2,2.635,2.635,0,0,0,1.033-1.792.251.251,0,0,1,.129-.19l2.278-1.226a1,1,0,0,0-.947-1.762L19.811,6.4a.25.25,0,0,1-.3-.044,2.612,2.612,0,0,0-3.209-.4.25.25,0,0,1-.248.007l-1.324-.713a.249.249,0,0,1-.129-.19,2.631,2.631,0,0,0-1.033-1.791.253.253,0,0,1-.1-.2V1.143a1,1,0,0,0-2,0V2.61a.248.248,0,0,1-.182.24A2.643,2.643,0,0,0,9.362,5.391a2.573,2.573,0,0,0,.023.342.248.248,0,0,1-.129.253L8.481,6.4a.25.25,0,0,1-.295-.044,2.6,2.6,0,0,0-3.7,0,.252.252,0,0,1-.295.043L2.268,5.37a1,1,0,0,0-.947,1.762L3.6,8.358a.253.253,0,0,1,.129.19A2.633,2.633,0,0,0,4.762,10.34a.25.25,0,0,1,.1.2v2.92a.25.25,0,0,1-.1.2A2.639,2.639,0,0,0,3.7,15.632a.248.248,0,0,1-.131.207L1.321,17.05a1,1,0,0,0,.947,1.762l2.035-1.1a.25.25,0,0,1,.284.033,2.63,2.63,0,0,0,3.106.289.249.249,0,0,1,.248-.006l1.324.712a.25.25,0,0,1,.129.19,2.631,2.631,0,0,0,1.033,1.791.253.253,0,0,1,.1.2v1.931a1,1,0,0,0,2,0V21.39a.251.251,0,0,1,.182-.241,2.636,2.636,0,0,0,1.9-2.215.249.249,0,0,1,.129-.19l1.324-.713a.25.25,0,0,1,.248.007,2.63,2.63,0,0,0,3.106-.289.252.252,0,0,1,.284-.033l2.035,1.1a1,1,0,0,0,1.354-.408ZM18.8,15.776a1.138,1.138,0,1,1-1.138-1.137A1.14,1.14,0,0,1,18.8,15.776ZM12,19.747a1.138,1.138,0,1,1,1.138-1.138A1.14,1.14,0,0,1,12,19.747Zm0-3.776a2.608,2.608,0,0,0-1.851.775.25.25,0,0,1-.295.044l-.775-.417a.25.25,0,0,1-.129-.254,2.577,2.577,0,0,0,.023-.343,2.642,2.642,0,0,0-1.928-2.54A.25.25,0,0,1,6.863,13V11a.248.248,0,0,1,.182-.24A2.636,2.636,0,0,0,8.94,8.548a.254.254,0,0,1,.13-.19l1.324-.712a.25.25,0,0,1,.248.006,2.612,2.612,0,0,0,3.209-.4.249.249,0,0,1,.295-.043l.775.417a.249.249,0,0,1,.129.254,2.562,2.562,0,0,0-.023.342,2.642,2.642,0,0,0,1.928,2.54.25.25,0,0,1,.182.24V13a.248.248,0,0,1-.182.24,2.642,2.642,0,0,0-1.928,2.54,2.589,2.589,0,0,0,.023.343.248.248,0,0,1-.129.253l-.775.418a.25.25,0,0,1-.295-.044A2.609,2.609,0,0,0,12,15.971Zm-5.665.944a1.138,1.138,0,1,1,1.138-1.139A1.14,1.14,0,0,1,6.335,16.915ZM5.2,8.224A1.138,1.138,0,1,1,6.335,9.361,1.14,1.14,0,0,1,5.2,8.224Zm7.941-2.833A1.138,1.138,0,1,1,12,4.253,1.139,1.139,0,0,1,13.138,5.391Zm4.527,1.694a1.138,1.138,0,1,1-1.138,1.139A1.14,1.14,0,0,1,17.665,7.085Z']],
  ScienceBacteria: ['science-bacteria', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,11H21.142a.5.5,0,0,1-.421-.229L17.247,5.366a.5.5,0,0,1,.031-.582L18.6,3.125a1,1,0,1,0-1.562-1.249L15.493,3.812A.5.5,0,0,1,15.1,4H8.544a.5.5,0,0,1-.39-.188L6.6,1.876A1,1,0,1,0,5.042,3.125L6.369,4.784a.5.5,0,0,1,.03.582L2.925,10.771A.5.5,0,0,1,2.5,11H1a1,1,0,0,0,0,2H2.5a.5.5,0,0,1,.421.23l3.474,5.4a.5.5,0,0,1-.03.583L5.042,20.875A1,1,0,0,0,6.6,22.125l1.551-1.937A.5.5,0,0,1,8.545,20H15.1a.5.5,0,0,1,.391.188l1.55,1.937a1,1,0,0,0,1.562-1.25l-1.327-1.658a.5.5,0,0,1-.03-.583l3.474-5.4a.5.5,0,0,1,.421-.23H23a1,1,0,0,0,0-2ZM9.573,16.5a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,9.573,16.5Zm4.177-3.491a2.75,2.75,0,1,1,2.75-2.75A2.75,2.75,0,0,1,13.75,13.009Z']],
  ScienceEarth: ['science-earth', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm8.159,15.009a.251.251,0,0,1-.356.251l-3.289-1.549a1,1,0,0,1-.561-.749,7.228,7.228,0,0,0-2.585-4.479A1,1,0,0,1,13,7.708V3.32a.25.25,0,0,1,.4-.2A16.991,16.991,0,0,1,20.159,15.009ZM10.6,3.12a.253.253,0,0,1,.262-.023A.249.249,0,0,1,11,3.321V7.708a1,1,0,0,1-.368.775,7.228,7.228,0,0,0-2.585,4.479,1,1,0,0,1-.561.749L4.2,15.26a.249.249,0,0,1-.355-.251A17,17,0,0,1,10.6,3.12ZM5,17.532a.247.247,0,0,1-.13-.226.251.251,0,0,1,.143-.219l3.435-1.618a1,1,0,0,1,.85,0,6.447,6.447,0,0,0,5.406,0,1,1,0,0,1,.85,0l3.435,1.618a.25.25,0,0,1,.013.445,14.709,14.709,0,0,1-14,0Z']],
  ScienceMolecule: ['science-molecule', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.944,11.685C22.579,9.669,23.321,7.609,22.393,6s-3.085-2-5.648-1.589A.5.5,0,0,1,16.2,4.1C15.271,1.673,13.858,0,12,0S8.729,1.673,7.8,4.1a.5.5,0,0,1-.545.314C4.693,4,2.538,4.391,1.607,6s-.186,3.669,1.449,5.686a.5.5,0,0,1,0,.629C1.421,14.331.679,16.391,1.607,18c.706,1.222,2.118,1.739,3.878,1.739a11.348,11.348,0,0,0,1.77-.15A.5.5,0,0,1,7.8,19.9C8.729,22.328,10.142,24,12,24s3.271-1.672,4.2-4.1a.5.5,0,0,1,.545-.315,11.234,11.234,0,0,0,1.77.151c1.76,0,3.172-.517,3.878-1.739.928-1.609.186-3.669-1.449-5.685A.5.5,0,0,1,20.944,11.685ZM3.34,7c.272-.473,1.046-.75,2.188-.75a8.73,8.73,0,0,1,1.04.067.5.5,0,0,1,.43.6C6.879,7.5,6.78,8.1,6.7,8.718a.5.5,0,0,1-.194.337c-.493.373-.967.76-1.415,1.157a.5.5,0,0,1-.732-.075C3.329,8.759,2.991,7.605,3.34,7ZM6.914,17.48a.5.5,0,0,1-.346.2C4.858,17.89,3.69,17.605,3.34,17s-.011-1.759,1.022-3.137a.5.5,0,0,1,.732-.075c.448.4.922.784,1.415,1.157a.5.5,0,0,1,.194.337c.077.614.176,1.219.295,1.8A.5.5,0,0,1,6.914,17.48ZM9.794,4.454C10.471,2.87,11.3,2,12,2s1.529.87,2.206,2.454a.5.5,0,0,1-.3.671c-.567.189-1.139.406-1.709.647a.5.5,0,0,1-.389,0c-.57-.241-1.143-.458-1.71-.647a.5.5,0,0,1-.3-.671Zm4.412,15.092C13.529,21.13,12.7,22,12,22s-1.529-.87-2.206-2.454a.5.5,0,0,1,.3-.671c.567-.19,1.139-.406,1.71-.647a.5.5,0,0,1,.388,0c.571.24,1.143.457,1.711.647a.5.5,0,0,1,.3.671Zm1.239-5.813a.5.5,0,0,1-.222.383q-.693.464-1.473.915t-1.528.818a.5.5,0,0,1-.443,0c-.5-.246-1.009-.518-1.529-.818s-1.011-.606-1.473-.915a.5.5,0,0,1-.222-.383Q8.5,12.9,8.5,12t.055-1.733a.5.5,0,0,1,.222-.383q.693-.464,1.473-.915t1.528-.818a.5.5,0,0,1,.444,0q.747.369,1.528.818t1.473.915a.5.5,0,0,1,.222.383Q15.5,11.1,15.5,12T15.445,13.733ZM20.66,17c-.348.605-1.516.889-3.228.683a.5.5,0,0,1-.43-.6c.119-.586.218-1.19.3-1.8a.5.5,0,0,1,.194-.337c.493-.373.967-.76,1.415-1.157a.5.5,0,0,1,.732.075C20.671,15.241,21.009,16.4,20.66,17Zm-1.022-6.863a.5.5,0,0,1-.732.075c-.448-.4-.922-.784-1.415-1.157a.5.5,0,0,1-.194-.337c-.077-.614-.176-1.218-.3-1.8a.5.5,0,0,1,.43-.6,8.759,8.759,0,0,1,1.041-.067c1.14,0,1.914.277,2.187.75C21.009,7.605,20.671,8.759,19.638,10.137Z', 'M10.044 12.000 A1.956 1.913 0 1 0 13.956 12.000 A1.956 1.913 0 1 0 10.044 12.000 Z']],
  ScienceAppleNewton: ['science-apple-newton', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.731,8.914c.515-.021.709-.333,1.331-.333s.816.312,1.33.333c.534.02.942-.534,1.282-1.027.7-1.009,1.232-2.85.516-4.093a1.989,1.989,0,0,0-1.681-1.019c-.524-.009-1.127.354-1.447.354s-.923-.363-1.447-.354A1.989,1.989,0,0,0,8.934,3.794c-.716,1.243-.183,3.084.516,4.093C9.79,8.38,10.2,8.934,10.731,8.914Z', 'M12.313,2.164a.747.747,0,0,0,.366-.1L13.7,1.5A.75.75,0,1,0,12.966.187L11.944.76a.75.75,0,0,0,.369,1.4Z', 'M17.64,23.215a6.052,6.052,0,0,0-3.964-3.694.247.247,0,0,1-.026-.469,4.255,4.255,0,1,0-3.365.017.246.246,0,0,1-.02.468,6.067,6.067,0,0,0-3.9,3.678.51.51,0,0,0,.477.693H17.163a.51.51,0,0,0,.477-.693Zm-6.186-5.853a2.264,2.264,0,0,1-1.608-1.4,2.149,2.149,0,0,1-.041-1.479.249.249,0,0,1,.373-.136A5.364,5.364,0,0,0,14,15.075c.062-.012.2-.079.2.089A2.254,2.254,0,0,1,11.454,17.362Z']],
  ScienceAtomPositiveNegative: ['science-atom-positive-negative', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.517,8.616a1,1,0,1,0-1.92.562,9.986,9.986,0,1,1-7.178-6.884A1,1,0,1,0,14.9.354a11.982,11.982,0,1,0,8.616,8.262Z', 'M12,5.75A6.25,6.25,0,1,0,18.25,12,6.257,6.257,0,0,0,12,5.75ZM15,13H13.5a.5.5,0,0,0-.5.5V15a1,1,0,0,1-2,0V13.5a.5.5,0,0,0-.5-.5H9a1,1,0,0,1,0-2h1.5a.5.5,0,0,0,.5-.5V9a1,1,0,0,1,2,0v1.5a.5.5,0,0,0,.5.5H15a1,1,0,0,1,0,2Z', 'M16.250 4.000 A3.250 3.250 0 1 0 22.750 4.000 A3.250 3.250 0 1 0 16.250 4.000 Z']],
  ScienceAppleGravity: ['science-apple-gravity', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,20h-1a.5.5,0,0,1-.5-.5v-2a1,1,0,0,0-2,0v2a.5.5,0,0,1-.5.5h-1a1,1,0,0,0-.625,1.781l2.5,2a1,1,0,0,0,1.25,0l2.5-2A1,1,0,0,0,14.5,20Z', 'M6,16.5H5a.5.5,0,0,1-.5-.5V14a1,1,0,0,0-2,0v2a.5.5,0,0,1-.5.5H1a1,1,0,0,0-.625,1.781l2.5,2a1,1,0,0,0,1.25,0l2.5-2A1,1,0,0,0,6,16.5Z', 'M23.944,17.169A1,1,0,0,0,23,16.5H22a.5.5,0,0,1-.5-.5V14a1,1,0,0,0-2,0v2a.5.5,0,0,1-.5.5H18a1,1,0,0,0-.625,1.781l2.5,2a1,1,0,0,0,1.25,0l2.5-2A1,1,0,0,0,23.944,17.169Z', 'M9.99,13.534c1.6,1.379,5.738-.373,7.576-2.506s1.883-4.881.284-6.259A6.774,6.774,0,0,0,16.7,3.931a.25.25,0,0,1-.078-.374l1.517-1.941A1,1,0,1,0,16.559.384L15.177,2.153a.25.25,0,0,1-.411-.024A5.468,5.468,0,0,0,13.621.843C12.021-.536,9.31-.085,7.472,2.048s-2.814,6.891-1.215,8.27,1.526.386,2.326,1.075S8.39,12.156,9.99,13.534ZM8.329,4.587a4.253,4.253,0,0,1,3.2-2.306.75.75,0,0,1,.211,1.486,2.747,2.747,0,0,0-2.07,1.492.75.75,0,1,1-1.342-.672Z']],
  ScienceBrain: ['science-brain', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,24a1,1,0,0,1-1-1V20.5a1,1,0,0,1,2,0V23A1,1,0,0,1,7,24Z', 'M16.287,24a1,1,0,0,1-1-1V21.242a1,1,0,0,1,1-1h.005c1.865.012,2.586-.122,3.006-.542a9.654,9.654,0,0,0,.52-3.959,1,1,0,0,1,1.038-1.022s.218.008.5.013a.5.5,0,0,0,.48-.665,15.564,15.564,0,0,0-1.07-2.248,5.221,5.221,0,0,1-.919-2.194A6.217,6.217,0,0,0,17.7,4.892,1,1,0,1,1,19.035,3.4a8.149,8.149,0,0,1,2.816,6.224c.039.123.395.747.655,1.2A8.73,8.73,0,0,1,24,14.86a1.708,1.708,0,0,1-.29,1.133,1.755,1.755,0,0,1-1.43.734.5.5,0,0,0-.482.474c-.072,1.408-.323,3.15-1.085,3.912a4.642,4.642,0,0,1-3.426,1.117V23A1,1,0,0,1,16.287,24Z', 'M7.321 9.250 A1.000 1.000 0 1 0 9.321 9.250 A1.000 1.000 0 1 0 7.321 9.250 Z', 'M16.332,4.625C15.626,3.4,14.005,3.09,12.07,3.378a.5.5,0,0,1-.538-.31C10.814,1.248,9.734,0,8.321,0S5.829,1.248,5.111,3.068a.5.5,0,0,1-.539.311C2.637,3.091,1.017,3.4.311,4.625-.472,5.979.352,7.66,1.36,8.941a.5.5,0,0,1,0,.618C.352,10.841-.47,12.525.311,13.875c.793,1.374,2.651,1.485,4.262,1.246a.5.5,0,0,1,.538.311c.718,1.82,1.8,3.068,3.21,3.068s2.493-1.248,3.211-3.068a.5.5,0,0,1,.538-.311,8.524,8.524,0,0,0,1.262.1,3.221,3.221,0,0,0,3-1.346c.706-1.224.165-2.783-1.052-4.314a.5.5,0,0,1,0-.622C16.5,7.408,17.038,5.849,16.332,4.625Zm-1.3.75c.266.461.033,1.321-.707,2.351a.5.5,0,0,1-.736.085c-.315-.277-.646-.547-.99-.809a.5.5,0,0,1-.192-.334c-.055-.428-.124-.849-.206-1.259a.5.5,0,0,1,.444-.6C13.537,4.728,14.682,4.769,15.033,5.375ZM8.543,12.25a.5.5,0,0,1-.443,0,20.391,20.391,0,0,1-2.266-1.309.5.5,0,0,1-.222-.384,21.11,21.11,0,0,1,0-2.614.5.5,0,0,1,.222-.384A20.568,20.568,0,0,1,8.1,6.25a.5.5,0,0,1,.444,0,20.7,20.7,0,0,1,2.265,1.308.5.5,0,0,1,.222.384,20.758,20.758,0,0,1,0,2.616.5.5,0,0,1-.222.384A20.7,20.7,0,0,1,8.543,12.25ZM8.321,1.5c.532,0,1.161.632,1.683,1.788a.5.5,0,0,1-.295.68c-.4.134-.8.286-1.2.452a.5.5,0,0,1-.386,0c-.4-.166-.8-.318-1.194-.452a.5.5,0,0,1-.295-.68C7.161,2.132,7.79,1.5,8.321,1.5ZM1.609,5.375c.35-.6,1.489-.648,2.388-.562a.5.5,0,0,1,.443.6c-.081.408-.149.826-.2,1.251A.5.5,0,0,1,4.042,7q-.521.394-.989.8a.5.5,0,0,1-.738-.087C1.806,6.994,1.263,5.976,1.609,5.375Zm0,7.75c-.346-.6.2-1.619.706-2.338a.5.5,0,0,1,.738-.087q.468.41.989.805a.5.5,0,0,1,.194.335c.055.425.123.845.205,1.253a.5.5,0,0,1-.442.6C2.738,13.813,1.876,13.585,1.609,13.125ZM8.321,17c-.531,0-1.16-.632-1.682-1.788a.5.5,0,0,1,.295-.68c.4-.134.8-.286,1.194-.453a.506.506,0,0,1,.386,0c.4.167.8.319,1.2.453a.5.5,0,0,1,.295.68C9.482,16.368,8.853,17,8.321,17Zm6.712-3.875c-.266.46-1.128.688-2.389.563a.5.5,0,0,1-.442-.6c.082-.41.151-.832.206-1.26A.5.5,0,0,1,12.6,11.5c.344-.262.675-.532.99-.809a.5.5,0,0,1,.736.085C15.066,11.8,15.3,12.664,15.033,13.125Z']],
  ScienceElecricityPower: ['science-elecricity-power', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,5h9a2,2,0,0,0,0-4H8A2,2,0,0,0,8,5Z', 'M14.5,11h-4a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z', 'M14.5,7.25h-4a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z', 'M14.5,14.75h-4a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z', 'M7.343,7.932A1.243,1.243,0,0,0,6.229,7.25H5.462a.5.5,0,0,1-.5-.5V5a.75.75,0,0,0-1.336-.469L.275,8.719a1.251,1.251,0,0,0,.977,2.031h.71a.5.5,0,0,1,.5.5V13.5a.75.75,0,0,0,1.356.441L7.24,9.235A1.246,1.246,0,0,0,7.343,7.932Z', 'M23.863,8.682A1.244,1.244,0,0,0,22.749,8h-.768a.5.5,0,0,1-.5-.5V5.75a.75.75,0,0,0-1.335-.469L16.8,9.469a1.251,1.251,0,0,0,.977,2.031h.709a.5.5,0,0,1,.5.5v2.25a.749.749,0,0,0,.519.713.739.739,0,0,0,.231.037.75.75,0,0,0,.607-.309L23.76,9.985A1.246,1.246,0,0,0,23.863,8.682Z', 'M18.227,19.017a.251.251,0,0,1-.187-.36l.815-1.63a1,1,0,0,0-1.789-.895l-1.3,2.592a.5.5,0,0,1-.447.276H9.678a.5.5,0,0,1-.448-.276L7.922,16.108A1,1,0,0,0,6.133,17l.828,1.657a.246.246,0,0,1,0,.227.251.251,0,0,1-.185.132A1.5,1.5,0,0,0,5.5,20.5V22a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1V20.5A1.5,1.5,0,0,0,18.227,19.017Z']],
  ScienceElectricity: ['science-electricity', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.25,12.25h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M2.25,20.75H2a.5.5,0,0,1-.5-.5V20A.75.75,0,0,0,0,20v1.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,0-1.5Z', 'M.75,17.75A.75.75,0,0,0,1.5,17V16A.75.75,0,0,0,0,16v1A.75.75,0,0,0,.75,17.75Z', 'M2.25,10.75H.75A.75.75,0,0,0,0,11.5V13a.75.75,0,0,0,1.5,0v-.25a.5.5,0,0,1,.5-.5h.25a.75.75,0,0,0,0-1.5Z', 'M16.5,11.5a.75.75,0,0,0,.75.75h1a.75.75,0,0,0,0-1.5h-1A.75.75,0,0,0,16.5,11.5Z', 'M23.25,19.25a.75.75,0,0,0-.75.75v.25a.5.5,0,0,1-.5.5h-.25a.75.75,0,0,0,0,1.5h1.5A.75.75,0,0,0,24,21.5V20A.75.75,0,0,0,23.25,19.25Z', 'M23.25,15.25a.75.75,0,0,0-.75.75v1A.75.75,0,0,0,24,17V16A.75.75,0,0,0,23.25,15.25Z', 'M23.25,10.75h-1.5a.75.75,0,0,0,0,1.5H22a.5.5,0,0,1,.5.5V13A.75.75,0,0,0,24,13V11.5A.75.75,0,0,0,23.25,10.75Z', 'M17.25,18.5h-8a.5.5,0,0,0-.5.5v.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,0-.5.5V22a.5.5,0,0,0,.5.5h1a.5.5,0,0,1,.5.5v.5a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5V19A.5.5,0,0,0,17.25,18.5Z', 'M7,17.25a.75.75,0,0,0,0-1.5H6.75a.5.5,0,0,1-.5-.5V15a.75.75,0,0,0-1.5,0v.25a.5.5,0,0,1-.5.5H4a.75.75,0,0,0,0,1.5h.25a.5.5,0,0,1,.5.5V18a.75.75,0,0,0,1.5,0v-.25a.5.5,0,0,1,.5-.5Z', 'M20,15.75H17a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z', 'M9.7,11.541a.5.5,0,0,1,.307.437,1.924,1.924,0,0,0,.986,1.671.5.5,0,0,1,.258.437V14.5a.75.75,0,0,0,1.5,0v-.414a.5.5,0,0,1,.258-.437,1.924,1.924,0,0,0,.986-1.671.5.5,0,0,1,.307-.437,6,6,0,1,0-4.6,0ZM12,2a4,4,0,0,1,1.429,7.736.5.5,0,0,1-.679-.467V8.018a.5.5,0,0,1,.146-.354L14.03,6.53a.75.75,0,0,0-1.06-1.06l-.616.616a.5.5,0,0,1-.708,0L11.03,5.47A.75.75,0,0,0,9.97,6.53L11.1,7.664a.5.5,0,0,1,.146.354V9.269a.5.5,0,0,1-.679.467A4,4,0,0,1,12,2Z']],
  ScienceBlackHole: ['science-black-hole', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.25,12c0-2.364-.657-4.75-2.125-4.75S7,9.636,7,12s.657,4.75,2.125,4.75S11.25,14.364,11.25,12ZM8.89,14.656A8.009,8.009,0,0,1,8.5,12a8.014,8.014,0,0,1,.39-2.656.25.25,0,0,1,.47,0A8.014,8.014,0,0,1,9.75,12a8.014,8.014,0,0,1-.39,2.656.25.25,0,0,1-.47,0Z', 'M15,3a8.96,8.96,0,0,0-3.446.683,9.089,9.089,0,0,0-1.933,1.1,1,1,0,0,0,1.2,1.6,7,7,0,0,1,10.909,3.668.25.25,0,0,1-.352.293L16.391,7.857a5.779,5.779,0,0,0-2.572-.607H12.426a.75.75,0,0,0,0,1.5h1.393a4.272,4.272,0,0,1,1.9.449l3.155,1.577a.25.25,0,0,1-.112.474H13a.75.75,0,0,0,0,1.5h5.764a.25.25,0,0,1,.112.474L15.721,14.8a4.272,4.272,0,0,1-1.9.449H12.426a.75.75,0,0,0,0,1.5h1.393a5.779,5.779,0,0,0,2.572-.607l4.982-2.491a.25.25,0,0,1,.352.293,7,7,0,0,1-11.007,3.593,1,1,0,1,0-1.225,1.581A9,9,0,1,0,15,3Z', 'M5.25,7.25H3.768A.5.5,0,0,1,3.414,7.1L2.28,5.97A.75.75,0,0,0,1,6.5V7a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5A.25.25,0,0,1,1,9v.5a.75.75,0,0,0,1.28.53L3.414,8.9a.5.5,0,0,1,.354-.146H5.25a.75.75,0,0,0,0-1.5Z', 'M5.25,15.25H3.768a.5.5,0,0,1-.354-.146L2.28,13.97A.75.75,0,0,0,1,14.5V15a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5A.25.25,0,0,1,1,17v.5a.75.75,0,0,0,1.28.53L3.414,16.9a.5.5,0,0,1,.354-.146H5.25a.75.75,0,0,0,0-1.5Z', 'M4.28,9.97A.75.75,0,0,0,3,10.5v.245a.5.5,0,0,1-.5.5H.75a.75.75,0,0,0,0,1.5H2.5a.5.5,0,0,1,.5.5V13.5a.75.75,0,0,0,1.28.53l1.5-1.5a.749.749,0,0,0,0-1.06Z']],
  ScienceCells: ['science-cells', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.375,12.5v-1a1,1,0,0,0-2,0v1a1,1,0,0,0,2,0Z', 'M8.338,19.365l-.866-.5a1,1,0,0,0-1,1.732l.866.5a1,1,0,1,0,1-1.732Z', 'M16.265,19.365l-.865.5a1,1,0,1,0,1,1.732l.865-.5a1,1,0,1,0-1-1.732Z', 'M20.229,12.5v1a1,1,0,0,0,2,0v-1a1,1,0,0,0-2,0Z', 'M16.265,5.635l.866.5a1,1,0,1,0,1-1.732l-.866-.5a1,1,0,0,0-1,1.732Z', 'M8.338,5.635l.866-.5A1,1,0,1,0,8.2,3.4l-.866.5a1,1,0,1,0,1,1.732Z', 'M4.125,7.313a1,1,0,1,1,0-1.324,1,1,0,1,0,1.5-1.328,3,3,0,1,0,.006,3.974,1,1,0,1,0-1.5-1.322Z', 'M4.125,18.063a1,1,0,1,1,0-1.324,1,1,0,1,0,1.5-1.328,3,3,0,1,0,.006,3.974,1,1,0,1,0-1.5-1.322Z', 'M21.125,10.9a3,3,0,0,0,2.25-1.017,1,1,0,0,0-1.5-1.322,1,1,0,1,1,0-1.324,1,1,0,1,0,1.5-1.328A3,3,0,1,0,21.125,10.9Z', 'M21.875,19.063a1,1,0,1,1,0-1.324,1,1,0,1,0,1.5-1.328,3,3,0,1,0,.006,3.974,1,1,0,0,0-1.5-1.322Z', 'M12.874,6a3,3,0,0,0,2.25-1.016,1,1,0,1,0-1.5-1.324,1,1,0,1,1,0-1.323,1,1,0,0,0,1.5-1.327A3,3,0,1,0,12.874,6Z', 'M12.875,21.661a1,1,0,1,1,0-1.324,1,1,0,0,0,1.5-1.327,3,3,0,1,0,.006,3.973,1,1,0,1,0-1.5-1.322Z']],
  ScienceMomentum: ['science-momentum', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.509,6.381A.25.25,0,0,1,16.722,6H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,6H2a.5.5,0,0,1,.5.5v6.292a.5.5,0,0,1-.312.464,3.5,3.5,0,1,0,4.577,4.506.252.252,0,0,1,.47,0,3.5,3.5,0,1,0,4.577-4.506.5.5,0,0,1-.312-.464V6.5A.5.5,0,0,1,12,6h1.52a.734.734,0,0,1,.629.358l3.56,5.806a.5.5,0,0,1-.024.558,3.5,3.5,0,1,0,5.8.252h0a3.508,3.508,0,0,0-3.561-1.623.5.5,0,0,1-.508-.231ZM9.5,12.792a.5.5,0,0,1-.312.464,3.518,3.518,0,0,0-1.956,1.99.248.248,0,0,1-.464,0,3.518,3.518,0,0,0-1.956-1.99.5.5,0,0,1-.312-.464V6.5A.5.5,0,0,1,5,6H9a.5.5,0,0,1,.5.5Z']],
  ScienceMolecules: ['science-molecules', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.055,4.7A1.945,1.945,0,1,0,20.111,2.75,1.945,1.945,0,0,0,22.055,4.7Z', 'M8.666,10.529a1.945,1.945,0,1,0,1.945,1.944A1.944,1.944,0,0,0,8.666,10.529Z', 'M20.956,6.483A.749.749,0,1,0,19.681,5.7c-.278.45-.593.922-.938,1.411A.5.5,0,0,1,18,7.187,8.7,8.7,0,0,0,15.775,5.71a.5.5,0,0,1-.086-.857A25.147,25.147,0,0,1,18.4,3.092a.75.75,0,1,0-.72-1.315,31.527,31.527,0,0,0-4.43,3.063.5.5,0,0,1-.356.109q-.364-.031-.737-.031a8.7,8.7,0,0,0-1.237.088.5.5,0,0,1-.385-.105C7.649,2.58,3.278-.426,1.656,1.191.25,2.6,2.259,6.023,4.477,8.952a.5.5,0,0,1,.041.539,8.624,8.624,0,0,0-1.03,4.1,8.9,8.9,0,0,0,.048.913.492.492,0,0,1-.1.355C1.165,17.826-.965,21.375.462,22.8a1.681,1.681,0,0,0,1.244.457c3.072,0,9.173-5.231,12.383-8.44A49.113,49.113,0,0,0,20.956,6.483ZM2.723,2.859a.5.5,0,0,1,.6-.592A16.467,16.467,0,0,1,8.587,5.283a.25.25,0,0,1-.047.426,8.712,8.712,0,0,0-2.75,2,.25.25,0,0,1-.385-.021A14.471,14.471,0,0,1,2.723,2.859ZM5.786,19.883a12.641,12.641,0,0,1-3.661,1.89.5.5,0,0,1-.595-.59,12.868,12.868,0,0,1,2.225-4.228.251.251,0,0,1,.23-.1.247.247,0,0,1,.2.15A8.692,8.692,0,0,0,5.83,19.5a.247.247,0,0,1,.065.2A.25.25,0,0,1,5.786,19.883Zm2.232-1.636a.5.5,0,0,1-.669-.046,6.664,6.664,0,0,1,9.5-9.346.5.5,0,0,1,.033.672c-1.141,1.387-2.452,2.829-3.855,4.231A57.134,57.134,0,0,1,8.018,18.247Z', 'M13.18,20.176a6.785,6.785,0,0,1-2.662-.125,1,1,0,0,0-.491,1.939,8.689,8.689,0,0,0,2.129.264,8.874,8.874,0,0,0,1.328-.1,1,1,0,0,0-.3-1.977Z', 'M20.688,15.1a8.9,8.9,0,0,0-.062-3.392,1,1,0,1,0-1.957.413,6.714,6.714,0,0,1-1.984,6.356.5.5,0,0,1-.645.029q-.7-.543-1.475-1.193a.756.756,0,0,0-1,.027.731.731,0,0,0,.029,1.1c2.469,2.067,6.182,4.825,8.418,4.825a1.71,1.71,0,0,0,1.26-.465c1.108-1.108.27-3.568-2.491-7.316A.5.5,0,0,1,20.688,15.1Zm1.378,6.523a.5.5,0,0,1-.459.132,11.561,11.561,0,0,1-3.3-1.632.252.252,0,0,1-.04-.388A8.6,8.6,0,0,0,19.9,17.482a.25.25,0,0,1,.431-.027A11.66,11.66,0,0,1,22.2,21.167.5.5,0,0,1,22.066,21.625Z']],
  ScienceMolecule1: ['science-molecule-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.47,9.118a.5.5,0,0,1-.321-.475,7.524,7.524,0,0,0-1.605-4.635A6.958,6.958,0,0,0,6.469,3.982a7.662,7.662,0,0,0-1.61,4.661.5.5,0,0,1-.322.473A7.144,7.144,0,0,0,0,15.75a7.008,7.008,0,0,0,7,7,7.1,7.1,0,0,0,4.67-1.633.5.5,0,0,1,.651,0A7.089,7.089,0,0,0,17,22.75a7.008,7.008,0,0,0,7-7A7.144,7.144,0,0,0,19.47,9.118ZM8.05,5.207a4.958,4.958,0,0,1,7.911.023,5.434,5.434,0,0,1,1.168,3.722.5.5,0,0,1-.2.35L12.3,12.775a.5.5,0,0,1-.6,0L7.072,9.3a.5.5,0,0,1-.2-.353A5.561,5.561,0,0,1,8.05,5.207ZM7,20.75a5.006,5.006,0,0,1-5-5,5.112,5.112,0,0,1,3.51-4.857.5.5,0,0,1,.45.077L10.8,14.6a.5.5,0,0,1,.2.4v3.756a.5.5,0,0,1-.116.321A4.955,4.955,0,0,1,7,20.75Zm15-5a5.006,5.006,0,0,1-5,5,4.845,4.845,0,0,1-3.887-1.67A.5.5,0,0,1,13,18.764V15a.5.5,0,0,1,.2-.4l4.84-3.631a.5.5,0,0,1,.451-.076A5.111,5.111,0,0,1,22,15.75Z']],
  SciencePhysicsLaw1: ['science-physics-law_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,0H.5A.5.5,0,0,0,0,.5v2A.5.5,0,0,0,.5,3h8a.5.5,0,0,1,.5.5v.876a.5.5,0,0,1-.318.466A5.008,5.008,0,0,0,5.5,9.5v7A.5.5,0,0,1,5,17H4.5a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V19a2,2,0,0,0-2-2H8a.5.5,0,0,1-.5-.5V13.97a.249.249,0,0,1,.381-.212,5,5,0,0,0,7.185-2.221.252.252,0,0,1,.206-.147.249.249,0,0,1,.228.108l3.12,4.564a.5.5,0,0,1-.131.7l-.826.565a1,1,0,0,0,.38,1.808l3.475.654a1.061,1.061,0,0,0,.185.017,1,1,0,0,0,.982-.816l.653-3.474A1,1,0,0,0,21.791,14.5l-.825.565a.5.5,0,0,1-.7-.131c-1.182-1.728-5.672-8.3-5.685-8.312a5.025,5.025,0,0,0-2.268-1.78A.5.5,0,0,1,12,4.376V3.5a.5.5,0,0,1,.5-.5h11a.5.5,0,0,0,.5-.5V.5A.5.5,0,0,0,23.5,0ZM12.144,7.155a.249.249,0,0,1,.265.034,3,3,0,1,1-3.818,0A.25.25,0,0,1,9,7.381V9a1.5,1.5,0,0,0,3,0V7.381A.249.249,0,0,1,12.144,7.155Z']],
  SciencePerspective: ['science-perspective', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.982,22.821l-1.746-9A1.051,1.051,0,0,0,21.186,13H16.25a.5.5,0,0,0-.5.5V14a4.268,4.268,0,0,0,2.76,3.981,1.753,1.753,0,0,1,1.147,1.635,1.722,1.722,0,0,1-1.094,1.628A18.94,18.94,0,0,1,12,22.25a18.93,18.93,0,0,1-6.562-1.006,1.722,1.722,0,0,1-1.095-1.628A1.753,1.753,0,0,1,5.49,17.981,4.268,4.268,0,0,0,8.25,14v-.5a.5.5,0,0,0-.5-.5h-4.5a1.056,1.056,0,0,0-1.041.778l-2.183,9A1.019,1.019,0,0,0,1.068,24H22.933A1.021,1.021,0,0,0,23.982,22.821Z', 'M9.4,15.97a.5.5,0,0,0,.425.671,26.383,26.383,0,0,0,4.355.009.5.5,0,0,0,.427-.672,5.72,5.72,0,0,1-.32-1.346.5.5,0,0,0-.534-.443c-.531.04-1.092.061-1.665.061-.635,0-1.253-.025-1.831-.074a.5.5,0,0,0-.539.444A5.7,5.7,0,0,1,9.4,15.97Z', 'M8.011,18.115a5.723,5.723,0,0,1-1.813,1.2.331.331,0,0,0,.015.618A18.354,18.354,0,0,0,12,20.75a18.354,18.354,0,0,0,5.787-.817.331.331,0,0,0,.015-.618A5.727,5.727,0,0,1,16,18.128a.5.5,0,0,0-.43-.135,22.768,22.768,0,0,1-3.524.257,22.386,22.386,0,0,1-3.6-.271A.5.5,0,0,0,8.011,18.115Z', 'M14.113,10.9a.5.5,0,0,0-.359-.152H10.246a.5.5,0,0,0-.5.516c.006.179,0,1,0,.9a.5.5,0,0,0,.454.5,21.689,21.689,0,0,0,3.587.016.5.5,0,0,0,.459-.5c0-.71,0-.765,0-.916A.5.5,0,0,0,14.113,10.9Z', 'M3.037,9.75H21.963a.54.54,0,0,0,.44-.215.466.466,0,0,0,.077-.418L21,4.117a.532.532,0,0,0-.518-.367H17.467a.25.25,0,0,0-.126.466A2.03,2.03,0,0,1,18.5,6c0,2.393-4.072,2.75-6.5,2.75S5.5,8.393,5.5,6A2.03,2.03,0,0,1,6.659,4.216a.25.25,0,0,0-.126-.466H4.889a.538.538,0,0,0-.508.337l-1.851,5a.464.464,0,0,0,.057.435A.54.54,0,0,0,3.037,9.75Z', 'M10.625,5.75A.625.625,0,0,1,10,5.125a.51.51,0,0,0-.567-.508C6.751,4.91,6.75,5.672,6.75,6c0,.41,0,1.5,5.25,1.5S17.25,6.41,17.25,6c0-.328,0-1.09-2.683-1.383A.51.51,0,0,0,14,5.125a.625.625,0,0,1-1.25,0V4a.5.5,0,0,1,.5-.5H14a.75.75,0,0,0,.53-1.28l-2-2a.749.749,0,0,0-1.06,0l-2,2A.75.75,0,0,0,10,3.5h.75a.5.5,0,0,1,.5.5V5.125A.625.625,0,0,1,10.625,5.75Z']],
  ScienceProjection: ['science-projection', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,16.75a8,8,0,1,0-8-8A8.009,8.009,0,0,0,12,16.75ZM6.252,9.69a.5.5,0,0,1,.391-.19h.284a.75.75,0,0,0,0-1.5H6.643a.5.5,0,0,1-.486-.614A5.861,5.861,0,0,1,6.526,6.3.5.5,0,0,1,6.982,6h2.19a.75.75,0,0,0,0-1.5H8.425a.25.25,0,0,1-.156-.446,5.989,5.989,0,0,1,7.717.215.25.25,0,0,1-.014.386A.749.749,0,0,0,16.427,6h.591a.5.5,0,0,1,.456.295,5.989,5.989,0,0,1,.37,1.091A.5.5,0,0,1,17.356,8H15.427a.75.75,0,0,0,0,1.5h1.929a.5.5,0,0,1,.488.614,5.964,5.964,0,0,1-.37,1.091.5.5,0,0,1-.456.295H13.927a.75.75,0,0,0,0,1.5h1.648a.25.25,0,0,1,.156.446,6,6,0,0,1-9.575-3.332A.5.5,0,0,1,6.252,9.69Z', 'M12.427,6h1a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M10,9.5h2.5a.75.75,0,0,0,0-1.5H10a.75.75,0,0,0,0,1.5Z', 'M8.927,13h2a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M23.832,11.805a1,1,0,0,0-1.664-1.11L17.28,18.027a.5.5,0,0,1-.417.223H7.136a.5.5,0,0,1-.416-.223L1.832,10.7a1,1,0,0,0-1.664,1.11L4.25,17.927a.25.25,0,0,1-.153.383,2.508,2.508,0,0,0-1.8,1.562l-.507,1.352A1.5,1.5,0,0,0,3.194,23.25H20.806a1.5,1.5,0,0,0,1.4-2.027l-.506-1.35a2.511,2.511,0,0,0-1.8-1.563.25.25,0,0,1-.153-.383ZM8.75,21.75a1,1,0,1,1,1-1A1,1,0,0,1,8.75,21.75Zm5.25-.5a.5.5,0,0,1-1,0v-1a.5.5,0,0,1,1,0Zm2,0a.5.5,0,0,1-1,0v-1a.5.5,0,0,1,1,0Z']],
  ScienceGraph: ['science-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,11.492a1,1,0,0,0-1-1H15.88a.5.5,0,0,1-.494-.58c.546-3.409,1.228-5.42,3.256-5.42,1.277,0,2.538,1.595,3.137,3.971a1,1,0,0,0,1.94-.489c-.854-3.382-2.8-5.482-5.077-5.482-3.822,0-4.742,3.793-5.307,7.574a.5.5,0,0,1-.494.426H5.5a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5H7a1,1,0,0,0,.759-1.651l-3-3.5a1.031,1.031,0,0,0-1.518,0l-3,3.5A1,1,0,0,0,1,5.492H2.5a.5.5,0,0,1,.5.5v17a1,1,0,0,0,2,0v-10a.5.5,0,0,1,.5-.5h6.9a.5.5,0,0,1,.494.579c-.546,3.409-1.228,5.421-3.256,5.421A2.532,2.532,0,0,1,7.79,17.356a1,1,0,1,0-1.58,1.225,4.356,4.356,0,0,0,3.432,1.911c3.822,0,4.741-3.793,5.307-7.574a.5.5,0,0,1,.494-.426H23A1,1,0,0,0,24,11.492Z']],
  ScienceDna: ['science-dna', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.946,6.593a1,1,0,0,0-1.268-.624.563.563,0,0,1-.581-.136L18.166,1.9a.564.564,0,0,1-.135-.58A1,1,0,1,0,16.139.677a8.937,8.937,0,0,0,.245,6.413,6.937,6.937,0,0,1,.3,4.525.25.25,0,0,1-.419.112L12.276,7.741a.25.25,0,0,1,.111-.418A7.107,7.107,0,0,1,14.1,7.076a1,1,0,0,0-.021-2h-.02a9.255,9.255,0,0,0-6.3,2.682,9.114,9.114,0,0,0-1.98,9.94,6.975,6.975,0,0,1,.406,1.27.251.251,0,0,1-.422.23L4.124,17.559a.249.249,0,0,1-.028-.32,1,1,0,0,0-.818-1.574H3.241a8.926,8.926,0,0,0-2.563.472,1,1,0,0,0,.644,1.893.563.563,0,0,1,.581.136L5.834,22.1a.564.564,0,0,1,.135.58,1,1,0,1,0,1.892.646,8.937,8.937,0,0,0-.245-6.413,6.937,6.937,0,0,1-.3-4.525.25.25,0,0,1,.419-.112l3.986,3.986a.25.25,0,0,1-.111.418,7.107,7.107,0,0,1-1.712.247,1,1,0,0,0,.021,2h.02a9.255,9.255,0,0,0,6.3-2.682,9.114,9.114,0,0,0,1.98-9.94,6.975,6.975,0,0,1-.406-1.27.251.251,0,0,1,.422-.23l1.638,1.639a.249.249,0,0,1,.028.32,1,1,0,0,0,.818,1.574h.037a8.926,8.926,0,0,0,2.563-.472A1,1,0,0,0,23.946,6.593Zm-8.609,7.668a6.966,6.966,0,0,1-.509.567,6.866,6.866,0,0,1-.569.509.5.5,0,0,1-.665-.036L8.7,10.406a.5.5,0,0,1-.036-.667,6.966,6.966,0,0,1,.509-.567,6.866,6.866,0,0,1,.569-.509.5.5,0,0,1,.665.036L15.3,13.594A.5.5,0,0,1,15.337,14.261Z']],
  ScienceMagnet: ['science-magnet', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.5,0a1,1,0,0,0-1,1v.705a.25.25,0,0,1-.474.112L11.4.553A1,1,0,0,0,9.5,1V7a1,1,0,0,0,2,0V6.3a.25.25,0,0,1,.474-.111l.631,1.264A1,1,0,0,0,14.5,7V1A1,1,0,0,0,13.5,0Z', 'M11.8,18h1.7a1,1,0,0,0,0-2H11.8a2.3,2.3,0,0,0-1.278,4.219l1.84,1.226A.3.3,0,0,1,12.2,22H10.5a1,1,0,0,0,0,2h1.7a2.3,2.3,0,0,0,1.278-4.219l-1.84-1.226A.3.3,0,0,1,11.8,18Z', 'M0.000 12.000 A1.500 1.500 0 1 0 3.000 12.000 A1.500 1.500 0 1 0 0.000 12.000 Z', 'M1.407 17.249 A1.500 1.500 0 1 0 4.407 17.249 A1.500 1.500 0 1 0 1.407 17.249 Z', 'M5.250 21.093 A1.500 1.500 0 1 0 8.250 21.093 A1.500 1.500 0 1 0 5.250 21.093 Z', 'M1.407 6.751 A1.500 1.500 0 1 0 4.407 6.751 A1.500 1.500 0 1 0 1.407 6.751 Z', 'M5.250 2.907 A1.500 1.500 0 1 0 8.250 2.907 A1.500 1.500 0 1 0 5.250 2.907 Z', 'M21.000 12.000 A1.500 1.500 0 1 0 24.000 12.000 A1.500 1.500 0 1 0 21.000 12.000 Z', 'M19.593 17.249 A1.500 1.500 0 1 0 22.593 17.249 A1.500 1.500 0 1 0 19.593 17.249 Z', 'M15.750 21.093 A1.500 1.500 0 1 0 18.750 21.093 A1.500 1.500 0 1 0 15.750 21.093 Z', 'M19.593 6.751 A1.500 1.500 0 1 0 22.593 6.751 A1.500 1.500 0 1 0 19.593 6.751 Z', 'M15.750 2.907 A1.500 1.500 0 1 0 18.750 2.907 A1.500 1.500 0 1 0 15.750 2.907 Z']],
  SciencePerspectiveAlternate: ['science-perspective-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.967,21.643l-1.636-9A2,2,0,0,0,20.364,11H16.293a.25.25,0,0,1-.235-.334A1,1,0,0,1,17,10h4.148a2,2,0,0,0,1.923-2.55l-1.429-5A2.007,2.007,0,0,0,19.719,1H18.151a1,1,0,0,0,0,2h1.19a.5.5,0,0,1,.481.363l1.144,4A.5.5,0,0,1,20.485,8H3.6a.5.5,0,0,1-.471-.668l1.429-4A.5.5,0,0,1,5.031,3h1.12a1,1,0,0,0,0-2H4.678A2.006,2.006,0,0,0,2.794,2.327l-1.785,5A2,2,0,0,0,2.892,10H7a1,1,0,0,1,.943.666A.25.25,0,0,1,7.708,11H4.046A1.991,1.991,0,0,0,2.1,12.557l-2.044,9A2,2,0,0,0,2,24H22a2,2,0,0,0,1.967-2.357ZM9.966,10.1a.252.252,0,0,1,.2-.1h3.675a.25.25,0,0,1,.243.308,3.035,3.035,0,0,0-.081.708.249.249,0,0,1-.17.236A5.9,5.9,0,0,1,12,11.5a5.906,5.906,0,0,1-1.83-.248A.249.249,0,0,1,10,11.016a2.993,2.993,0,0,0-.082-.708A.254.254,0,0,1,9.966,10.1Zm-.057,3.437a.25.25,0,0,1,.3-.2,9.612,9.612,0,0,0,3.589,0,.25.25,0,0,1,.3.2,5.97,5.97,0,0,0,.414,1.355.246.246,0,0,1,0,.209.25.25,0,0,1-.16.134A9.3,9.3,0,0,1,12,15.5a9.307,9.307,0,0,1-2.342-.27.251.251,0,0,1-.163-.343A5.97,5.97,0,0,0,9.909,13.532ZM8.472,16.927A9.73,9.73,0,0,0,12,17.5a9.718,9.718,0,0,0,3.534-.575.5.5,0,0,1,.534.079,6.068,6.068,0,0,0,1.3.864.25.25,0,0,1-.037.463A19.3,19.3,0,0,1,12,19a19.245,19.245,0,0,1-5.312-.666.25.25,0,0,1-.038-.463,6.023,6.023,0,0,0,1.287-.863A.5.5,0,0,1,8.472,16.927ZM21.785,21.82A.5.5,0,0,1,21.4,22H2.628a.5.5,0,0,1-.488-.611l1.818-8A.5.5,0,0,1,4.445,13H7.672a.25.25,0,0,1,.244.3,4.052,4.052,0,0,1-2.541,2.946,2,2,0,0,0-1.309,1.865,1.97,1.97,0,0,0,1.252,1.863A19.271,19.271,0,0,0,12,21a19.277,19.277,0,0,0,6.683-1.024,1.97,1.97,0,0,0,1.252-1.863,2,2,0,0,0-1.31-1.865A4.054,4.054,0,0,1,16.084,13.3a.253.253,0,0,1,.051-.209A.248.248,0,0,1,16.329,13h3.618a.5.5,0,0,1,.492.411l1.454,8A.5.5,0,0,1,21.785,21.82Z', 'M10.514,4.961a17.139,17.139,0,0,1-2.477-.288,1.989,1.989,0,0,1-.889-.435A1,1,0,0,0,5.5,5c0,.5,0,2,6.5,2s6.5-1.5,6.5-2a1,1,0,0,0-1.647-.762,2,2,0,0,1-.889.435,17.139,17.139,0,0,1-2.477.288A.463.463,0,0,1,13,4.5a.5.5,0,0,1,.5-.5H14a1,1,0,0,0,.707-1.707l-2-2a1,1,0,0,0-1.414,0l-2,2A1,1,0,0,0,10,4h.5a.5.5,0,0,1,.5.5.462.462,0,0,1-.486.461Z']],
  SciencePhysicsLaw: ['science-physics-law', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,4a1.752,1.752,0,0,0-1.75-1.75H1.75A1.752,1.752,0,0,0,0,4V20a1.752,1.752,0,0,0,1.75,1.75h20.5A1.752,1.752,0,0,0,24,20ZM3.25,14.5a.5.5,0,0,0,.5.5H4.5a.75.75,0,0,1,0,1.5H3.75a.5.5,0,0,0-.5.5v.5a.5.5,0,0,0,.5.5H5.5a.75.75,0,0,1,0,1.5h-2a1.752,1.752,0,0,1-1.75-1.75v-4A1.752,1.752,0,0,1,3.5,12h2a.75.75,0,0,1,0,1.5H3.75a.5.5,0,0,0-.5.5ZM9,17.75H8a.75.75,0,0,1,0-1.5H9a.75.75,0,0,1,0,1.5Zm0-2.5H8a.75.75,0,0,1,0-1.5H9a.75.75,0,0,1,0,1.5Zm6.75,3.5a.75.75,0,0,1-1.5,0V16.605a.249.249,0,0,0-.366-.221.824.824,0,0,1-.384.082.811.811,0,0,1-.384-.083.25.25,0,0,0-.366.222V18.75a.75.75,0,0,1-1.5,0v-6a.75.75,0,0,1,1.421-.335l.605,1.21a.25.25,0,0,0,.448,0l.605-1.21a.75.75,0,0,1,1.421.335ZM20.5,18a.75.75,0,0,1,0,1.5,3.75,3.75,0,0,1,0-7.5.75.75,0,0,1,0,1.5,2.25,2.25,0,0,0,0,4.5Zm.563-9.421a.25.25,0,0,0,.237.171h.2a.75.75,0,0,1,0,1.5H18.3a.75.75,0,0,1-.45-1.35l2.56-1.921a.84.84,0,0,0,.34-.679.85.85,0,1,0-1.7,0,.75.75,0,1,1-1.5,0,2.35,2.35,0,1,1,3.761,1.88l-.161.12A.25.25,0,0,0,21.063,8.579Z']]
};
exports["default"] = _default;